module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('foobar-header'), _vm._v(" "), _c('intro'), _vm._v(" "), _c('section-intro', {
    attrs: {
      "title": _vm.$t('message.title.main.foobar_beer')
    }
  }), _vm._v(" "), _c('foobar', {
    attrs: {
      "foobar-id": _vm.$route.params.id
    }
  }), _vm._v(" "), _c('foobar-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baac18e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Foobar.vue
// module id = 1851
// module chunks = 1